import cn from '@/utils/cn';

type TProps = {
  className?: string;
  indicator?: string;
};

const RequiredIndicator = ({ className, indicator = '*' }: TProps) => {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'relative top-1 left-1 inline-block origin-bottom-left scale-150 text-secondary-red leading-none',
        className
      )}
    >
      {indicator}
    </span>
  );
};

export default RequiredIndicator;
